// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1GGG6","title":"Info_title__2fSDA","selects":"Info_selects__1YHuM","requiredAsterisk":"Info_requiredAsterisk__JngZm"};